var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              "门店是独立维护的主体，门店账号创建时的「归属门店」就从这里选。"
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: {
                      placeholder: "门店名称/编号/联系人/电话",
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loadList(1)
                      },
                    },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "正常", value: 0 } }),
                      _c("el-option", { attrs: { label: "停用", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadList(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.resetQuery } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "mb14",
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.openEdit()
                },
              },
            },
            [_vm._v("新增门店")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.coverOf(row)
                          ? _c("el-image", {
                              staticClass: "cover-image",
                              attrs: {
                                src: _vm.coverOf(row),
                                "preview-src-list": _vm.parseImages(row.images),
                                fit: "cover",
                              },
                            })
                          : _c("span", { staticClass: "sub-line" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "storeNo", label: "门店编号", width: "110" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(" " + _vm._s(row.contactName || "-") + " "),
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v(_vm._s(row.contactPhone || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "address",
                  label: "地址",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "关联团长", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        Number(row.leaderId) > 0
                          ? [
                              _vm._v(" " + _vm._s(row.leaderName || "-") + " "),
                              _c("div", { staticClass: "sub-line" }, [
                                _vm._v("#" + _vm._s(row.leaderId)),
                              ]),
                            ]
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v("未关联")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-switch", {
                          attrs: {
                            value: row.status === 0,
                            "active-text": "正常",
                            "inactive-text": "停用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggleStatus(row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "160" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "danger-text",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              total: Number(_vm.total),
              "page-size": Number(_vm.query.limit),
              "current-page": Number(_vm.query.page),
            },
            on: { "current-change": _vm.loadList },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑门店" : "新增门店",
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店名称：", prop: "storeName" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "64", placeholder: "请输入门店名称" },
                    model: {
                      value: _vm.form.storeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "storeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.storeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "门店编号：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32", placeholder: "留空由系统生成" },
                    model: {
                      value: _vm.form.storeNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "storeNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.storeNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32", placeholder: "请输入联系人姓名" },
                    model: {
                      value: _vm.form.contactName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "contactName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话：", prop: "contactPhone" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20", placeholder: "请输入联系电话" },
                    model: {
                      value: _vm.form.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "contactPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "255", placeholder: "请输入详细地址" },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "address",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "门店图片：" } }, [
                _c(
                  "div",
                  { staticClass: "store-images" },
                  [
                    _vm._l(_vm.form.imageList, function (url, idx) {
                      return _c(
                        "div",
                        { key: url + idx, staticClass: "store-image-item" },
                        [
                          _c("img", {
                            staticClass: "store-image",
                            attrs: { src: url },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete store-image-del",
                            on: {
                              click: function ($event) {
                                return _vm.removeImage(idx)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    _vm.form.imageList.length < _vm.IMAGE_LIMIT
                      ? _c(
                          "el-upload",
                          {
                            staticClass: "store-image-upload",
                            attrs: {
                              action: "",
                              "http-request": _vm.uploadImage,
                              "show-file-list": false,
                              accept: "image/*",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "store-image-placeholder" },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "form-tip" }, [
                  _vm._v(
                    "门头、店内实景等，最多 " +
                      _vm._s(_vm.IMAGE_LIMIT) +
                      " 张，第一张作为封面。"
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "关联团长：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        placeholder: "按昵称或手机号搜索团长",
                        "remote-method": _vm.searchLeader,
                        loading: _vm.leaderLoading,
                        "no-data-text": "没搜到团长，可先留空，之后再补",
                      },
                      model: {
                        value: _vm.form.leaderId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "leaderId", $$v)
                        },
                        expression: "form.leaderId",
                      },
                    },
                    _vm._l(_vm.leaderList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: _vm.leaderLabel(item), value: item.id },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "佣金、核销仍按团长记账；留空表示暂不关联，不影响门店建账号。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("正常")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("停用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", maxlength: "255", rows: 2 },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "remark",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }